// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.togglebutton_switch__P70i8 {
    position: relative;
    display: block;
    width: 35px;
    height: 11px;
    padding: 3px;
    margin: 0 10px 10px 0;
    border-radius: 18px;
    cursor: pointer;
    top:4px;
    /* left: 35px; */
  }
  .togglebutton_switch-input__1jqgw {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .togglebutton_switch-label__BALtn {
    position: relative;
    display: block;
    height: inherit;
    font-size: 8px;
    text-transform: uppercase;
    background: #eceeef;
    border-radius: inherit;
    
  }
  .togglebutton_switch-label__BALtn:before, .togglebutton_switch-label__BALtn:after {
    position: absolute;
    top: 50%;
    margin-top: -0.5em;
    line-height: 1;
    transition: inherit;
  }
  .togglebutton_switch-label__BALtn:before {
    content: attr(data-off);
    right: 4px;
    color: #aaaaaa;
    
  }
  .togglebutton_switch-label__BALtn:after {
    content: attr(data-on);
    left: 4px;
    color: var(--call-to-action1);
    opacity: 0;
  }
  .togglebutton_switch-input__1jqgw:checked ~ .togglebutton_switch-label__BALtn {
    background: #EAF2FB;
    border-radius: 16px;
    opacity: 1;
  }
  .togglebutton_switch-input__1jqgw:checked ~ .togglebutton_switch-label__BALtn:before {
    opacity: 0;
  }
  .togglebutton_switch-input__1jqgw:checked ~ .togglebutton_switch-label__BALtn:after {
    opacity: 1;
  }
  .togglebutton_switch-handle__SacKC {
    position: absolute;
    top: -8px;
    left: -4px;
    width: 28px;
    height: 32px;
    border-radius: 100%;
    
  }
  .togglebutton_switch-handle__SacKC:before {
    content: "";
    position: absolute;
    top: 47%;
    left: 50%;
    margin: -6px 0 0 -6px;
    width: 15px;
    height: 15px;
    background: white 0% 0% no-repeat padding-box;
    background: var(--call-to-action1);
    opacity: 1;
    border-radius: 10px
  }
  .togglebutton_switch-input__1jqgw:checked ~ .togglebutton_switch-handle__SacKC {
    left: 10px; 
  }
  
  /* Transition
  ========================== */
  .togglebutton_switch-label__BALtn, .togglebutton_switch-handle__SacKC {
    transition: All 0.3s ease;
    -webkit-transition: All 0.3s ease;
    -moz-transition: All 0.3s ease;
    -o-transition: All 0.3s ease;
  }
  
  .togglebutton_label__bp87Z{
    color: #333;
    padding-right: 6px;
    margin: 2px 0 0 0;
  }
  
  .togglebutton_labelactive__a3GrV{
    color: var(--call-to-action1);
    padding-right: 6px;
    font-weight: bold;
    margin: 2px 0 0 0;
  }
  `, "",{"version":3,"sources":["webpack://./src/Components/Common/togglebutton.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,OAAO;IACP,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;;EAExB;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,cAAc;IAId,mBAAmB;EACrB;EACA;IACE,uBAAuB;IACvB,UAAU;IACV,cAAc;;EAEhB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,6BAA6B;IAC7B,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;;EAErB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,6CAA6C;IAC7C,kCAAkC;IAClC,UAAU;IACV;EACF;EACA;IACE,UAAU;EACZ;;EAEA;8BAC4B;EAC5B;IACE,yBAAyB;IACzB,iCAAiC;IACjC,8BAA8B;IAC9B,4BAA4B;EAC9B;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB","sourcesContent":[".switch {\r\n    position: relative;\r\n    display: block;\r\n    width: 35px;\r\n    height: 11px;\r\n    padding: 3px;\r\n    margin: 0 10px 10px 0;\r\n    border-radius: 18px;\r\n    cursor: pointer;\r\n    top:4px;\r\n    /* left: 35px; */\r\n  }\r\n  .switch-input {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    opacity: 0;\r\n  }\r\n  .switch-label {\r\n    position: relative;\r\n    display: block;\r\n    height: inherit;\r\n    font-size: 8px;\r\n    text-transform: uppercase;\r\n    background: #eceeef;\r\n    border-radius: inherit;\r\n    \r\n  }\r\n  .switch-label:before, .switch-label:after {\r\n    position: absolute;\r\n    top: 50%;\r\n    margin-top: -0.5em;\r\n    line-height: 1;\r\n    -webkit-transition: inherit;\r\n    -moz-transition: inherit;\r\n    -o-transition: inherit;\r\n    transition: inherit;\r\n  }\r\n  .switch-label:before {\r\n    content: attr(data-off);\r\n    right: 4px;\r\n    color: #aaaaaa;\r\n    \r\n  }\r\n  .switch-label:after {\r\n    content: attr(data-on);\r\n    left: 4px;\r\n    color: var(--call-to-action1);\r\n    opacity: 0;\r\n  }\r\n  .switch-input:checked ~ .switch-label {\r\n    background: #EAF2FB;\r\n    border-radius: 16px;\r\n    opacity: 1;\r\n  }\r\n  .switch-input:checked ~ .switch-label:before {\r\n    opacity: 0;\r\n  }\r\n  .switch-input:checked ~ .switch-label:after {\r\n    opacity: 1;\r\n  }\r\n  .switch-handle {\r\n    position: absolute;\r\n    top: -8px;\r\n    left: -4px;\r\n    width: 28px;\r\n    height: 32px;\r\n    border-radius: 100%;\r\n    \r\n  }\r\n  .switch-handle:before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 47%;\r\n    left: 50%;\r\n    margin: -6px 0 0 -6px;\r\n    width: 15px;\r\n    height: 15px;\r\n    background: white 0% 0% no-repeat padding-box;\r\n    background: var(--call-to-action1);\r\n    opacity: 1;\r\n    border-radius: 10px\r\n  }\r\n  .switch-input:checked ~ .switch-handle {\r\n    left: 10px; \r\n  }\r\n  \r\n  /* Transition\r\n  ========================== */\r\n  .switch-label, .switch-handle {\r\n    transition: All 0.3s ease;\r\n    -webkit-transition: All 0.3s ease;\r\n    -moz-transition: All 0.3s ease;\r\n    -o-transition: All 0.3s ease;\r\n  }\r\n  \r\n  .label{\r\n    color: #333;\r\n    padding-right: 6px;\r\n    margin: 2px 0 0 0;\r\n  }\r\n  \r\n  .labelactive{\r\n    color: var(--call-to-action1);\r\n    padding-right: 6px;\r\n    font-weight: bold;\r\n    margin: 2px 0 0 0;\r\n  }\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switch": `togglebutton_switch__P70i8`,
	"switch-input": `togglebutton_switch-input__1jqgw`,
	"switch-label": `togglebutton_switch-label__BALtn`,
	"switch-handle": `togglebutton_switch-handle__SacKC`,
	"label": `togglebutton_label__bp87Z`,
	"labelactive": `togglebutton_labelactive__a3GrV`
};
export default ___CSS_LOADER_EXPORT___;
